import CustoService from "@/services/CustoService";

export const custo = {
  namespaced: true,
  state: {
    custo: {},
  },
  actions: {
    getCusto({ commit }, payload) {
      return CustoService.GetCusto(payload).then(
        (custo) => {
          return Promise.resolve(custo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAllCusto({ commit }) {
      return CustoService.GetAllCusto().then(
        (custo) => {
          return Promise.resolve(custo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCusto({ commit }, payload) {
      return CustoService.PostCusto(payload).then(
        (custo) => {
          return Promise.resolve(custo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCusto({ commit }, payload) {
      return CustoService.PutCusto(payload).then(
        (custo) => {
          return Promise.resolve(custo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCusto({ commit }, payload) {
      return CustoService.DeleteCusto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCustoOData({ commit }, payload) {
      return CustoService.GetCustoOData(payload).then(
        (custo) => {
          return Promise.resolve(custo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default custo;
